import { render, staticRenderFns } from "./photosDetail.vue?vue&type=template&id=45ecb25a&scoped=true&"
import script from "./photosDetail.vue?vue&type=script&lang=js&"
export * from "./photosDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ecb25a",
  null
  
)

export default component.exports